import { Svg } from './styles';
import useBackground from './vm';

export interface BackgroundProps {
  className?: string;
}

const Background = ({ className }: BackgroundProps) => {
  const { svgRef, inputRef, numNodes } = useBackground();

  return (
    <div className={className}>
      <Svg
        ref={svgRef}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1 0.625"
        width="1"
        height="0.625"
      >
        <radialGradient id="background-gradient">
          <stop offset="1" stopColor="#fff" />
          <stop offset="0" stopColor="#fff" />
        </radialGradient>
        <rect width="100%" height="100%" fill="url(#background-gradient)" />
        <g strokeWidth="0.00125"></g>
      </Svg>
      <input ref={inputRef} type="text" hidden value={numNodes} onChange={() => {}} />
    </div>
  );
};

export default Background;
